import { render } from "./IconStanding.vue?vue&type=template&id=6c4f0e8a&ts=true"
import script from "./IconStanding.vue?vue&type=script&lang=ts"
export * from "./IconStanding.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__